import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/routes/common/ProtectedRoute';
// import SuspenseWrapper from the correct path or create the file if missing
import { SuspenseWrapper } from '@/routes/common/SuspenseWrapper';

const StartupMessageList = lazy(() => import('@/pages/startup-messages/List'));
const StartupMessageCreate = lazy(() => import('@/pages/startup-messages/Create'));
const StartupMessageEdit = lazy(() => import('@/pages/startup-messages/Edit'));
const StartupMessageDetail = lazy(() => import('@/pages/startup-messages/Detail'));

export const startupMessageRoutes: RouteObject = {
  path: 'startup-messages',
  children: [
    {
      index: true,
      element: <Navigate to="list" replace />,
    },
    {
      path: 'list',
      element: (
        <ProtectedRoute pageKey="page:startup-messages:list">
          <SuspenseWrapper>
            <StartupMessageList />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'create',
      element: (
        <ProtectedRoute pageKey="page:startup-messages:create">
          <SuspenseWrapper>
            <StartupMessageCreate />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'edit/:id',
      element: (
        <ProtectedRoute pageKey="page:startup-messages:edit">
          <SuspenseWrapper>
            <StartupMessageEdit />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'detail/:id',
      element: (
        <SuspenseWrapper>
          <StartupMessageDetail />
        </SuspenseWrapper>
      ),
    },
  ],
};
